import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts-gl';

// 引入柱状图
import "echarts/lib/chart/bar";

// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';//effectScatter
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/axisPointer';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/legendScroll';

import { Layout, Table, Modal, Divider, Button, Row, Col, message, Select, Upload, Icon, Radio, Input } from 'antd';
import { getChartOption } from './chartOptions/index';

import emitter from '../Evt.js';

import moment from 'moment';
var moment_timezone = require('moment-timezone');

const { Content } = Layout;
const Option = Select.Option;
var languageMessages = window.appLocale.messages;


var statistics = [
    { 'sName': languageMessages['grandTotal/annualizedRateOfReturn'], 'name': [languageMessages['grandTotalRateOfReturn'], languageMessages['annualizedRateOfReturn']], 'xData': [], 'yName': '(%)', "data": [], color: ['#5470c6', '#fac858'], markPoint: { symbol: 'none', data: [], color: '#fac858' }, minInterval: 0 },
    { 'sName': languageMessages['profitFactor'], 'name': [languageMessages['profitFactor']], 'xData': [], 'yName': '', "data": [], color: ['#5470c6'], markPoint: { symbol: 'none', data: [], color: '#5470c6' }, minInterval: 0 },
    { 'sName': languageMessages['buyingPowerRequried'], 'name': [languageMessages['buyingPowerRequried']], 'xData': [], 'yName': '', "data": [], color: ['#fac858'], markPoint: { data: [] }, minInterval: 0 },
];

var incomes = {
    'sName': languageMessages['incomeCurve'],
    'xName': languageMessages['date'],
    'xData': [],
    'yName': languageMessages['totalRet'] + '(%)',
    'data': [
        {
            'name': languageMessages['strategyGains'],
            'color': '#ee6666',
            'data': []//[0.00, - 0.18, -0.55, 0.19, -0.96, 0.29, 0.26]
        },
        {
            'name': languageMessages['individualStockIncome'],
            'color': '#5470c6',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        },
        {
            'name': languageMessages['individualStocks+strategyStackingIncome'],
            'color': '#990000',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        }
    ],
};

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

var colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class OptimalGridResult extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.charts = {
            "statistics": null,
            "income": null
        }
        
        this.state = {
            spinLoadding: false,

            statisticsResult: [],

            conditions: [],

            income: '',
            trade: '',

            dataSource: [],

            modalTitle: '',
            modalBacktestId: '',
            modalSymbolCode: '',
            modalSymbolName: '',
            modalStrategyName: '',
            modalStrategyType: '',
            initCapital: 0,
            capital: 0,
            category: 3,
            gridCnt: 0,
            modalVisible: false,

            basePosition: 0,
            share: 0,

            promptModalVisible: false,

            tradeType: 0,

            broker: window.webType === 'US' ? 'TD' : 'Quancept',
            accountType: '0',

        }
    }
    
    componentDidMount() {
        const { statisticsResult } = this.props;
        
        this.setBacktestResult(statisticsResult);

        emitter.addListener("callSendTradeError", this.callSendTradeError);
        emitter.addListener("callDeployStrategy", this.callDeployStrategy);
    }

    componentWillUnmount() {
        emitter.removeListener('callSendTradeError', this.callSendTradeError);
        emitter.removeListener('callDeployStrategy', this.callDeployStrategy);
    }

    callSendTradeError = (status) => {
        let promptModalVisible = false;
        switch (status) {
            case 3:
                promptModalVisible = true;
                break;
            default:
                message.error(languageMessages['deployStrategySubmitFail'] + ', Error:' + status);
                break;
        }

        this.setState({ spinLoadding: false, modalVisible: false, promptModalVisible });
    }

    callDeployStrategy = (status, deployStrategy) => {
        this.setState({ spinLoadding: false, modalVisible: false }, () => {
            if (status == 0) {
                if (deployStrategy.TradeType == 0) {
                    //emitter.emit('callJump', 'realtime');
                    //history.push("/re");

                    var content = <span>{languageMessages['checkLiveTradeStatus']} <a href="javascript:;" onClick={this.jumpRealtime}>{languageMessages['checkLiveTradeStatusUrl']}</a></span>;
                    this.timerModal(languageMessages['newRealTradeSucc'], content);
                } else {
                    emitter.emit('callJump', 'simulated');
                    history.push("/si");
                }
            } else {
                message.error(languageMessages['deployStrategyFail'] + ', Error:' + status);
            }
        });
    }

    timerModal(title, content) {
        const modal = Modal.success({
            title: title,
            content: content,
        });

        /**
        var secondsToGo = 5;
        setTimeout(() => {
            modal.destroy();
        }, secondsToGo * 1000);
        */
    }

    jumpRealtime = e => {
        e.preventDefault();

        Modal.destroyAll();

        emitter.emit('callJump', 'realtime');
        history.push("/re");
    }

    resizeChart() {
        var statistics = this.charts['statistics'];
        var incomeChart = this.charts['income'];
        //var equityChart = this.charts['equity'];
        
        window.onresize = function () {
            if (incomeChart != null) incomeChart.resize();
            //if (equityChart != null) equityChart.resize();
            
            if (statistics != null) {
                for (let i = 0; i < 2; i++) {
                    statistics["statistics-" + i].resize();
                }
            }
        }
    }

    setIncomeData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    setStatisticsData(chartName, chartData) {
        this.charts[chartName] = {};

        let pdiv = document.getElementById(chartName)
        pdiv.innerHTML = ""
        for (let i = 0; i < chartData.length; i++) {
            let div = document.createElement("div");//创建一个div元素
            div.style.width = "33.3%";
            div.style.height = "360px";

            var ids = chartName + "-" + i;
            div.setAttribute("id", ids);
            pdiv.appendChild(div)

            //chartData[i].color = colors[i];

            this.charts[chartName][ids] = echarts.init(document.getElementById(ids));
            this.charts[chartName][ids].setOption(getChartOption('grid', chartData[i]));

            this.charts[chartName][ids].resize();
        }

        this.resizeChart();
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            //value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value = Number(value).toFixed(2);
            value += sign;
        }

        return value;
    }

    setBacktestResult(statisticsResult) {
        var conditions = [];

        this.charts = {
            "statistics": null,
            "income": null
        };

        for (var i = 0; i < 3; i++) {
            statistics[i].xData = [];
            statistics[i].data = [];
        }

        incomes.xData = [];
        incomes.data[0].data = [];
        incomes.data[1].data = [];
        incomes.data[2].data = [];

        var income = '';
        var trade = '';

        let modalBacktestId = '';
        let modalSymbolCode = '';
        let modalSymbolName = '';
        let modalStrategyType = '';
        let modalStrategyName = '';
        let capital = 0;
        let gridCnt = 0;
        
        var dataSource = [];

        if (statisticsResult.length > 0) {
            let maxProfitFactor = 0;

            statistics[0].data.push({ data: [], markPoint: { color: '#fff', data: [] } });
            statistics[0].data.push({ data: [], markPoint: { color: '#fff', data: [] } });

            statistics[1].data.push({ data: [], markPoint: { color: '#fff', data: [] } });
            statistics[2].data.push({ data: [], markPoint: { color: '#fff', data: [] } });

            for (var item in statisticsResult) {
                //var strategyName = strReplace(languageMessages['gridStrategy'], { '{num}': statisticsResult[item].gridCnt });

                if (modalBacktestId === '') modalBacktestId = statisticsResult[item].backtestId;
                if (modalSymbolCode === '') modalSymbolCode = statisticsResult[item].symbol;
                if (modalSymbolName === '') modalSymbolName = statisticsResult[item].symbolName;
                if (modalStrategyType === '') modalStrategyType = statisticsResult[item].d;
                

                var strategyName = statisticsResult[item].strategyName;
                strategyName = strategyName.replace('strategy', languageMessages['gridStrategy']);

                conditions.push({ 'id': statisticsResult[item].backtestId, 'name': strategyName });

                var initialRateOfReturnOnCapital = this.keepDecimals(statisticsResult[item].initialRateOfReturnOnCapital, '');
                var annualizedRateOfReturn = this.keepDecimals(statisticsResult[item].annualizedRateOfReturn, '');
                var profitFactor = this.keepDecimals(statisticsResult[item].profitFactor, '');
                var chartCapital = statisticsResult[item].capital;

                if (capital === 0) capital = chartCapital;
                if (gridCnt === 0) gridCnt = statisticsResult[item].gridCnt;
                
                statistics[0].xData.push(strategyName);
                statistics[1].xData.push(strategyName);

                statistics[0].data[0]["data"].push({ value: initialRateOfReturnOnCapital, label: { position: initialRateOfReturnOnCapital >= 0 ? 'top' : 'bottom' } });
                statistics[0].data[1]["data"].push({ value: annualizedRateOfReturn, label: { position: annualizedRateOfReturn >= 0 ? 'top' : 'bottom' } });

                if (profitFactor >= 100000) {
                    //statistics[1].markPoint.symbol = 'pin';

                    var color = window.webType === 'US' ? 'Darkgreen' : '#aa0000';
                    statistics[1].data[0]["data"].push({ value: profitFactor, label: { position: 'top' }, itemStyle: { color: color } });
                    statistics[1].data[0]["markPoint"]["color"] = color;
                    statistics[1].data[0]["markPoint"]["data"].push({ value: languageMessages['noLoss'], xAxis: parseInt(item), yAxis: profitFactor / 3 });
                } else {
                    statistics[1].data[0]["data"].push({ value: profitFactor, label: { position: profitFactor >= 0 ? 'top' : 'bottom' } });
                    if (statistics[1].data[0]["markPoint"]["data"].length == 0) {
                        statistics[1].data[0]["markPoint"] = { color: '#fff', data: [] };
                    }

                    var tmpProfitFactor = parseFloat(profitFactor);
                    var tmpMaxProfitFactor = parseFloat(maxProfitFactor);
                    if (tmpProfitFactor > tmpMaxProfitFactor) maxProfitFactor = profitFactor;
                }

                statistics[2].data[0]["data"].push({ value: chartCapital, label: { position: chartCapital >= 0 ? 'top' : 'bottom' } });
            }

            if (maxProfitFactor > 0) {
                for (var item in statistics[1].data[0]["data"]) {
                    if (statistics[1].data[0]["data"][item].value >= 100000) {
                        statistics[1].data[0]["data"][item].value = maxProfitFactor;
                    }
                }

                for (var ii in statistics[1].data[0]["markPoint"]["data"]) {
                    statistics[1].data[0]["markPoint"]["data"][ii].yAxis = maxProfitFactor / 3;
                }
            }

            if (conditions.length > 0) {
                income = conditions[0].id;//.push(conditions[0].id);
                //equity = conditions[0].id;
                trade = conditions[0].id;

                modalStrategyName = conditions[0].name;

                //var strategyName = strReplace(languageMessages['gridStrategy'], { '{num}': statisticsResult[item].gridCnt });
                //strategyName = statisticsResult[0].strategyName;

                var rateOfReturn = statisticsResult[0].equityCurve.rateOfReturn;
                var bRateOfReturn = statisticsResult[0].equityCurve.bRateOfReturn;

                incomes.xData = statisticsResult[0].equityCurve.date;
                //incomes.data[0].name = '策略收益';//window.webType === 'US' ? languageMessages['SP500'] : languageMessages['CSI300'];
                incomes.data[0].data = rateOfReturn;
                //incomes.data[1].name = '个股收益';//strategyName;
                incomes.data[1].data = bRateOfReturn;

                var superimposedIncome = [];
                for (var ii in rateOfReturn) {
                    var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                    superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
                }

                incomes.data[2].data = superimposedIncome;
                /**
                incomes.data.push({
                    'name': statisticsResult[0].strategyName,
                    'color': colors[0],
                    'data': statisticsResult[0].equityCurve.rateOfReturn
                });
                */

                if (statisticsResult[0].trades.length > 0) {
                    var trades = statisticsResult[0].trades;

                    /**
                     * 若 原方向=做空， 则
                       第一行， 方向= 卖出，价格=原“进仓价格”，成交量=abs(原“数量”）成交额=价格*成交量
                        第二行， 方向= 买入，价格=原“出仓价格”，成交量=abs(原“数量”）成交额=价格*成交量
                        若 原方向=做多， 则
                        将 第一行和第二行的方向互换

                        若 原方向=做空， 则
                        第一行， 方向= 卖出，成交价=原“进仓价格”，成交量=abs(原“数量”）成交额=价格*成交量，成交时间=原“进仓时间”
                        第二行， 方向= 买入，成交价=原“出仓价格”，成交量=abs(原“数量”）成交额=价格*成交量，成交时间=原“出仓时间”
                        若 原方向=做多， 则
                        将 第一行和第二行的方向互换
                     * 
                     */

                    var sequence = 1;
                    var index = 1;
                    for (var item in trades) {

                        var pnl = parseFloat(trades[item].pnl);
                        var pnlPercent = parseFloat(trades[item].pnlPercent);

                        var direction = '';
                        var tradeTime = trades[item].entryDatetime;
                        var strikePrice = '';
                        var volume = Math.abs(trades[item].quantity);
                        var turnover = 0;
                        if (trades[item].direction == 'L') {
                            direction = 'L';
                        } else {
                            direction = 'S';
                        }

                        tradeTime = trades[item].entryDatetime;
                        strikePrice = trades[item].entryPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: sequence,
                            symbolName: trades[item].symbol,
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: '',
                            pnlp: ''
                        });

                        index++;

                        if (trades[item].direction == 'L') {
                            direction = 'S';
                        } else {
                            direction = 'L';
                        }

                        tradeTime = trades[item].exitDatetime;
                        strikePrice = trades[item].exitPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: '',
                            symbolName: '',
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: pnl.toFixed(2),
                            pnlp: pnlPercent.toFixed(2)
                        });

                        sequence++;
                        index++;
                    }
                }
            }
        }

        this.setStatisticsData("statistics", statistics);
        this.setIncomeData("income", incomes);

        let initCapital = capital;
        this.setState({ conditions, income, trade, dataSource, statisticsResult, modalBacktestId, modalStrategyName, modalSymbolCode, modalSymbolName, modalStrategyType, initCapital, capital, gridCnt });
    }

    componentWillReceiveProps(props) {
        const { status, statisticsResult, basePosition, share } = props;

        switch (status) {
            case 'get_base_position_success':
                this.setState({
                    modalTitle: languageMessages['newRealTimeTrade'],
                    modalVisible: true,
                    basePosition,
                    share,
                    spinLoadding: false
                }, () => {
                    this.props.dispatch({ type: "action_empty" });
                });

                break;
            case 'get_base_position_fail':
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_empty" });
                });
                break;
            default:
                if (this.state.statisticsResult == statisticsResult) return;
                this.setBacktestResult(statisticsResult);
                break;
        }
    }

    onSelectConditionByIncome = e => {
        var { income } = this.state;

        try {
            var tags = e.currentTarget.getAttribute('data-value');
            if (income == tags) return;

            var nodes = e.target.parentNode.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                var dd = nodes[i].getAttribute('data-value');
                if (tags !== dd) {
                    if (nodes[i].classList.contains("checked")) {
                        nodes[i].classList.remove("checked");
                    }
                }
            }

            e.target.classList.add("checked");
            income = tags;

            const { statisticsResult } = this.props;

            let modalBacktestId = '';
            let modalStrategyName = '';
            let capital = 0;
            let gridCnt = 0;

            var tmpIncomes = statisticsResult.filter(function (e) { return income == e.backtestId; });
            if (tmpIncomes.length > 0) {
                //var strategyName = strReplace(languageMessages['gridStrategy'], { '{num}': tmpIncomes[0].gridCnt });

                var rateOfReturn = tmpIncomes[0].equityCurve.rateOfReturn;
                var bRateOfReturn = tmpIncomes[0].equityCurve.bRateOfReturn;

                incomes.xData = tmpIncomes[0].equityCurve.date;
                incomes.data[0].data = rateOfReturn;
                //incomes.data[1].name = strategyName;
                incomes.data[1].data = bRateOfReturn;

                var superimposedIncome = [];
                for (var ii in rateOfReturn) {
                    var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                    superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
                }

                incomes.data[2].data = superimposedIncome;
                /**
                incomes.data.push({
                    'name': statisticsResult[0].strategyName,
                    'color': colors[0],
                    'data': statisticsResult[0].equityCurve.rateOfReturn
                });
                */

                modalBacktestId = tmpIncomes[0].backtestId;
                modalStrategyName = tmpIncomes[0].strategyName.replace('strategy', languageMessages['gridStrategy']);
                capital = tmpIncomes[0].capital;
                gridCnt = tmpIncomes[0].gridCnt;

                this.setIncomeData("income", incomes);
            }

            let initCapital = capital;
            this.setState({ income, modalBacktestId, modalStrategyName, initCapital, capital, gridCnt });
        } catch (e) { }
    }

    onSelectConditionByTrades = e => {
        var { trade } = this.state;

        try {
            var tags = e.currentTarget.getAttribute('data-value');
            if (trade == tags) return;

            var nodes = e.target.parentNode.childNodes;
            for (var i = 0; i < nodes.length; i++) {
                var dd = nodes[i].getAttribute('data-value');
                if (tags !== dd) {
                    if (nodes[i].classList.contains("checked")) {
                        nodes[i].classList.remove("checked");
                    }
                }
            }

            e.target.classList.add("checked");
            trade = tags;

            var dataSource = [];

            var tmpTrades = this.props.statisticsResult.filter(function (e) { return e.backtestId == trade; });
            if (tmpTrades.length > 0) {
                var trades = tmpTrades[0].trades;

                var sequence = 1;
                var index = 1;
                for (var item in trades) {
                
                    var pnl = parseFloat(trades[item].pnl);
                    var pnlPercent = parseFloat(trades[item].pnlPercent);

                    var direction = '';
                    var tradeTime = trades[item].entryDatetime;
                    var strikePrice = '';
                    var volume = Math.abs(trades[item].quantity);
                    var turnover = 0;
                    if (trades[item].direction == 'L') {
                        direction = 'L';
                    } else {
                        direction = 'S';
                    }

                    tradeTime = trades[item].entryDatetime;
                    strikePrice = trades[item].entryPrice;
                    var tmpStrikePrice = parseFloat(strikePrice);
                    turnover = volume * tmpStrikePrice;
                    
                    dataSource.push({
                        key: index,//trades[item].backtestId,
                        sequence: sequence,
                        symbolName: trades[item].symbol,
                        tradeTime: tradeTime,
                        strikePrice: strikePrice,
                        direction: direction,
                        volume: volume,
                        turnover: turnover.toFixed(2),
                        pnl: '',
                        pnlp: ''
                    });

                    index++;

                    if (trades[item].direction == 'L') {
                        direction = 'S';
                    } else {
                        direction = 'L';
                    }

                    tradeTime = trades[item].exitDatetime;
                    strikePrice = trades[item].exitPrice;
                    var tmpStrikePrice = parseFloat(strikePrice);
                    turnover = volume * tmpStrikePrice;

                    dataSource.push({
                        key: index,//trades[item].backtestId,
                        sequence: '',
                        symbolName: '',
                        tradeTime: tradeTime,
                        strikePrice: strikePrice,
                        direction: direction,
                        volume: volume,
                        turnover: turnover.toFixed(2),
                        pnl: pnl.toFixed(2),
                        pnlp: pnlPercent.toFixed(2)
                    });

                    index++;
                    sequence++;
                }
            }
            
            this.setState({ trade, dataSource });
        } catch (e) { }
    }

    onSelAccountType = (e) => {
        this.setState({ accountType: e.target.value });
    }

    handleBrokerChange = (value) => {
        let broker = value.key;

        this.setState({ broker });
    }

    buildBindBroker = e => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.setState({ spinLoadding: false }, () => {
                this.props.dispatch({ type: "action_non_user" });
            });
        } else {
            this.props.dispatch({ type: "action_get_auth", payload: { u: user.username } });
        }
    }

    handleChangeCapital = e => {
        var capital = e.target.value;

        this.setState({
            capital: capital
        }, () => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                this.props.dispatch({ type: "action_get_base_position", payload: { u: user.username, cg: this.state.category, s: this.state.modalSymbolCode, g: this.state.gridCnt, c: capital == '' ? 0 : capital } });
            }
        });
    }

    handleBlurCapital = e => {
        e.preventDefault();

        var capital = e.target.value;

        this.setState({
            capital: capital
        }, () => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                this.props.dispatch({ type: "action_get_base_position", payload: { u: user.username, cg: this.state.category, s: this.state.modalSymbolCode, g: this.state.gridCnt, c: capital == '' ? 0 : capital } });
            }
        });
    }

    onRealTime = () => {
        this.setState({
            spinLoadding: true,
            tradeType: 0,
        }, () => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                this.props.dispatch({ type: "action_get_base_position", payload: { u: user.username, cg: this.state.category, s: this.state.modalSymbolCode, g: this.state.gridCnt, c: 0 } });
            }
        });
    }

    onSimulation = () => {
        this.setState({
            modalTitle: languageMessages['newSimulationTrade'],
            modalVisible: true,
            tradeType: 1,
        });
    }

    onMultiOptimization = () => {
        history.push({ pathname: '/ob', state: { backtestId: this.state.modalBacktestId } });
        //history.push({ pathname: '/oo', state: { backtestId: this.state.modalBacktestId } });
    }

    onScrollOptimization = () => {
        //history.push({ pathname: '/ob', state: { backtestId: this.state.modalBacktestId } });
        history.push({ pathname: '/oo', state: { backtestId: this.state.modalBacktestId } });
    }

    renderModalContent() {
        if (this.state.tradeType == 0) {
            return this.renderModalRealTimeContent();
        } else {
            return this.renderModalSimulationContent();
        }
    }

    renderModalSimulationContent() {
        let newDate = moment().add(1, 'd');
        let fromDate = newDate.format('YYYY-MM-DD 09:30:00');
        let endDate = window.webType === 'US' ? newDate.add(2, 'w').format('YYYY-MM-DD 16:00:00') : newDate.add(2, 'w').format('YYYY-MM-DD 15:00:00');
        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['symbolCode']}：</Col>
                <Col span={16}>
                    <div className="common-gutter-row">{this.state.modalSymbolCode + ' ' + this.state.modalSymbolName}</div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradingStraregy']}：</Col>
                <Col className="common-gutter-row" span={16}>{this.state.modalStrategyName}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['strategyType']}：</Col>
                <Col className="common-gutter-row" span={16}>{this.state.modalStrategyType === '0' ? languageMessages['crossDay'] : languageMessages['intraday']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['startTime']}：</Col>
                <Col className="common-gutter-row" span={16}>{fromDate}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['endTime']}：</Col>
                <Col className="common-gutter-row" span={16}>{endDate}</Col>
            </Row>
        </div>
    }

    renderModalRealTimeContent() {
        return window.webType === 'US' ? this.renderModalRealTimeContentForUs() : this.renderModalRealTimeContentForCn();
    }

    renderModalRealTimeContentForCn() {
        const brokerItems = [];
        brokerItems.push({ 'id': 'Quancept', 'name': '华鑫证券' });

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['chooseBroker']}：</Col>
                <Col span={16}>
                    <Select labelInValue size='small' value={{ key: this.state.broker }} style={{ width: '120px' }} onChange={this.handleBrokerChange} dropdownClassName="common-dropdownClassName">
                        {
                            brokerItems.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))
                        }
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['accountType']}：</Col>
                <Col className="common-gutter-row" span={16}>
                    <div>
                        <Radio.Group size='small' value={this.state.accountType} onChange={this.onSelAccountType} buttonStyle="solid" style={{ marginBottom: '10px' }}>
                            <Radio.Button value="0">{languageMessages['cashAccount']}</Radio.Button>
                            <Radio.Button value="1">{languageMessages['financingAccount']}</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div>
                        {languageMessages['buyingPowerRequried']} <span style={{ marginLeft: 10 }}>{this.state.initCapital}</span>
                    </div>
                    <div>
                        {languageMessages['Buying power to allocate']}
                        <span style={{ marginLeft: 10 }}>
                            <Input type="text" size='small' style={{ width: 120 }} value={this.state.capital} onChange={this.handleChangeCapital} onBlur={this.handleBlurCapital} placeholder='' data-value='capital' />
                        </span>
                    </div>
                    <div style={{ display: this.state.accountType == '0' ? '' : 'none' }}>
                        {languageMessages['minimumPositionRequired']}
                        <span style={{ marginLeft: 10 }}>{this.state.basePosition}</span>
                    </div>
                </Col>
            </Row>

        </div>
    }

    renderModalRealTimeContentForUs() {
        const brokerItems = [];
        brokerItems.push({ 'id': 'TD', 'name': 'TdAmeritrade' }, { 'id': 'IB', 'name': 'IB' });

        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['chooseBroker']}：</Col>
                <Col span={16}>
                    <Select labelInValue size='small' value={{ key: this.state.broker }} style={{ width: '120px' }} onChange={this.handleBrokerChange} dropdownClassName="common-dropdownClassName">
                        {
                            brokerItems.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))
                        }
                    </Select>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['accountType']}：</Col>
                <Col className="common-gutter-row" span={16}>
                    <div>
                        <Radio.Group size='small' value={this.state.accountType} onChange={this.onSelAccountType} buttonStyle="solid" style={{ marginBottom: '10px' }}>
                            <Radio.Button value="0">{languageMessages['cashAccount']}</Radio.Button>
                            <Radio.Button value="1">{languageMessages['financingAccount']}</Radio.Button>
                        </Radio.Group>
                    </div>
                    <div>
                        {languageMessages['buyingPowerRequried']} <span style={{ marginLeft: 10 }}>{this.state.initCapital}</span>
                    </div>
                    <div>
                        {languageMessages['Buying power to allocate']}
                        <span style={{ marginLeft: 10 }}>
                            <Input type="text" size='small' style={{ width: 120 }} value={this.state.capital} onChange={this.handleChangeCapital} onBlur={this.handleBlurCapital} placeholder='' data-value='capital' />
                        </span>
                    </div>
                    <div style={{ display: this.state.accountType == '0' ? '' : 'none' }}>
                        {languageMessages['minimumPositionRequired']} <span style={{ marginLeft: 10 }}>{this.state.basePosition}</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['requiredSteps']}：</Col>
                <Col className="common-gutter-row" span={16}></Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={24}>
                    <div style={{ display: this.state.broker == 'TD' ? '' : 'none' }}><Button size='small' onClick={this.buildBindBroker}>{languageMessages['login td account']}</Button></div>
                    <div style={{ display: this.state.broker == 'IB' ? '' : 'none' }}>
                        <div>{languageMessages['tradeLiveInfo01']}</div>
                        <div>{languageMessages['tradeLiveInfo02']}</div>
                        <div>
                            <Upload name='file' action="#"
                                beforeUpload={this.beforeUpload}
                                onChange={this.handleUploadChange}
                                fileList={this.state.fileList}>
                                <Button size='small'><Icon type="upload" /> {languageMessages['downloadQuanceptAgent']} </Button>
                            </Upload>
                        </div>
                        <div>{languageMessages['tradeLiveInfo03']}</div>
                    </div>
                </Col>
            </Row>
        </div>
    }

    beforeUpload = (file) => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
            return false;
        } else {
            return true;
        }
    }

    handleUploadChange = (info) => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let fileList = info.fileList;

            if (info.file.status !== undefined) {
                this.setState({ fileList });
            }

            if (info.file.status === 'done') {
                //
            } else if (info.file.status === 'error') {
                this.setState({ fileList: [] });
            }
        }
    }

    handleOk = e => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { tradeType, modalBacktestId, modalSymbolCode, modalStrategyType, category, capital } = this.state;

            if (tradeType == 0 && this.state.initCapital > capital) {
                message.info(languageMessages['Buying power to allocate tips']);
            } else {
                this.setState({ spinLoadding: true }, () => {
                    this.props.dispatch({
                        type: "action_send_hub_message", payload: {
                            service: 'SendTrade',
                            userId: user.username,
                            msg: {
                                Type: 'deployStrategy',
                                TradeType: tradeType,
                                BacktestId: modalBacktestId,
                                StrategyId: 0,
                                SymbolCode: modalSymbolCode,
                                Category: category,
                                Capital: capital,
                                DayTradeOnly: modalStrategyType,
                                ReqId: guid()
                            }
                        }
                    });
                });
            }
        }
    }

    handleCancel = e => {
        this.setState({ modalVisible: false, spinLoadding: false });
    }

    handlePromptOk = e => {
        emitter.emit('callJump', 'simulated');
        history.push("/si");
    }
    handlePromptCancel = e => {
        this.setState({ promptModalVisible: false });
    }

    render() {
        var { conditions, income, trade, dataSource } = this.state;

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                //sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                //sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['tradeTimes'],
                dataIndex: 'tradeTime',
                //sorter: (a, b) => a.tradeTimes - b.tradeTimes,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['strikePrice'],
                dataIndex: 'strikePrice',
                align: 'right',
                //sorter: (a, b) => a.strikePrice - b.strikePrice,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['tradeSize'],
                dataIndex: 'volume',
                align: 'right',
                //sorter: (a, b) => a.volume - b.volume,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['dollars'],
                dataIndex: 'turnover',
                align: 'right',
                //sorter: (a, b) => a.turnover - b.turnover,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnls'],
                dataIndex: 'pnl',
                align: 'right',
                //sorter: (a, b) => a.pnl - b.pnl,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnl'] !== '' && row['pnl'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['gain'] + '(%)',
                dataIndex: 'pnlp',
                align: 'right',
                //sorter: (a, b) => a.pnlp - b.pnlp,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnlp'] !== '' && row['pnlp'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }
        ];

        var className = window.webType === 'US' ? 'common-tag common-tag-us' : 'common-tag';

        return (<Content>
            <div className='common-title'><Divider type="vertical" />{languageMessages['backtestDetails']}</div>

            <div id="statistics" style={{ display: "flex", flexWrap: "wrap", marginTop: "20px" }} > </div>

            <div className='common-title'><Divider type="vertical" />{languageMessages['fundsCurve']}</div>
            <div>
                {conditions.map((tag, index) => (
                    <div key={index} className={income == tag.id ? className + " checked" : className} onClick={this.onSelectConditionByIncome} data-value={tag.id}>{tag.name}</div>
                ))}
                <div className='common-trade-btn'>
                    <Button size='small' onClick={this.onMultiOptimization}>{languageMessages['Multi-dimensionalOptimization']}</Button>
                    <Button size='small' style={{ marginLeft: 8 }} onClick={this.onRealTime}>{languageMessages['goRealTime']}</Button>
                    <Button size='small' style={{ marginLeft: 8 }} onClick={this.onSimulation}>{languageMessages['goSimulation']}</Button>
                </div>
            </div>
            <div id="income" style={{ height: "500px", marginTop: "20px" }} > </div>

            <div className='common-title'><Divider type="vertical" />{languageMessages['tradeDetails']}</div>
            <div>
                {conditions.map((tag, index) => (
                    <div key={index} className={trade == tag.id ? className + " checked" : className} onClick={this.onSelectConditionByTrades} data-value={tag.id}>{tag.name}</div>
                ))}
            </div>

            <Table bordered size='small' locale={{ emptyText: ' ' }} columns={columns} dataSource={dataSource} pagination={dataSource.length >= 60 ? { pageSize: 60 } : false} />
            <Modal
                title={this.state.modalTitle}
                visible={this.state.modalVisible}
                maskClosable={false}
                onOk={this.handleOk}
                confirmLoading={this.state.spinLoadding}
                onCancel={this.handleCancel}>
                {this.renderModalContent()}
            </Modal>

            <Modal
                title={languageMessages['prompt']}
                visible={this.state.promptModalVisible}
                onOk={this.handlePromptOk}
                onCancel={this.handlePromptCancel}>
                <div dangerouslySetInnerHTML={{ __html: languageMessages['simulated trading limit'] }} />
                <p>{languageMessages['simulated trading limit prompt']}</p>
            </Modal>
        </Content>);
    }
}

export { OptimalGridResult as default }

/**
function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(BacktestResult);
export { page as default }
 */